<template>
<div>
<div class="auditng">
  <div class="fixed">
    <div class="head">
      <div class="text text1">账户算力</div>
      <div class="text money text2">{{moneyFmt(account.myGrade)}}</div>
      <div class="text text3"><span>团队算力 {{moneyFmt(account.teamGrade)}}</span> <span>累计佣金 ￥{{moneyFmt(account.incomeAmount)}}</span></div>
      <div class="text text4"><span>昨日算力 {{moneyFmt(account.recharge)}}</span> <span>昨日收益 ＋￥{{moneyFmt(account.income)}}</span></div>
    </div>
  </div>
  <div class="fix"></div>
  <div class="last_income_text">近期佣金</div>
  <div class="income_year" @click="selectDate">{{year}}年{{month}}月
      <van-icon name="arrow-down" class="arrow-down" />
    </div>
  <div class="detail" style="overflow: auto; height: 60%;">
       <!-- 下拉刷新组件 -->
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <!-- 列表组件 -->
      <van-list v-model="loading" :finished="finished" :finished-text="bomTitle"   @load="onLoad" :offset="200"  :immediate-check="false" > 
        <!-- 列表项 -->
        <div v-if="incomeList.length == 0" class="team_empty"><van-empty description="暂无数据" /></div>
        <div v-else class="list">
        <div class="list_item b-b" v-for="(item, index) in incomeList" :key="index">
          <div style="background-color: rgb(255,141,141);
            width: 8px;
            height: 8px;
            border-radius: 8px;
            margin-right: 9px;"></div>
          <div class="item_l">
              <div class="text1 mb20" style="color: #fff;">达人佣金</div>
              <div class="text2">{{item.createTime}}</div>
          </div>
          <div class="item_r">
            <div class="text1 mb20" style="color: rgb(255,141,141);">+{{moneyFmt(item.changeAmount)}}</div>
            <div class="text2">余额:<span style="font-weight: 700;">{{moneyFmt(item.oldBalance)}}</span></div>
          </div>
        </div>
      </div>
      </van-list>
    </van-pull-refresh>

  </div>
</div>
<van-popup v-model="show" bind:close="onClose"  catchtouchmove='true' position="bottom" round closeable>
  <div class="alert" style="margin-top: 25px;margin-right: 20px"> 
    <van-datetime-picker
        v-model="currentDate"
        type="year-month"
        title="选择年月"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        @confirm="confirmTime"
/>
  </div>
</van-popup>
<BackButton @back="goBack" :boxLeft=-15 :boxTop=20><van-image :src="require('@/assets/img/back_img.png')" width="3rem" height="3rem"></van-image></BackButton>
</div>
</template>

<script>

import { moneyFmt } from "@/utils/moneyUtil";
import { getOfficialAccountInfo,getOfficialList } from "@/api/income.js";

export default {
  name: "IncomePage",

  data() {
    return {
    show: false, // 选择时间弹窗
    account :{
      teamGrade: 0,
      myGrade: 0,
      income: 0,
      recharge: 0,
      incomeAmount: 0
    },
    year: new Date().getFullYear(),
    month: new Date().getMonth() + 1,
    pageNum: 1,
    pageTotal: 0,
    incomeList:[],
    minDate: new Date(2025, 5, 1),
    maxDate: new Date(2050, 12, 31),
    currentDate: new Date(),
    isLoading: false, // 控制下拉刷新的加载状态
    loading: false, // 控制上拉加载的加载状态
    finished: false, // 是否已加载完全部数据
    bomTitle: '', // 上拉加载完成时的文本
    pageTotal: 0,
    };
  },
  computed: {
    isLogin() {
      return this.$store.getters.token;
    },
  },
  created() {
    //必须是登录过的用户 才能获取购物车列表
    if (this.isLogin) {
      this.getWxCodeAccountInfo();
    }
    let getMonth = new Date().getMonth() + 1
    this.month = getMonth.toString().padStart(2, '0')
  },
    mounted() {
    this.informPort(); //列表数据接口
    },
  methods: {
    moneyFmt(num){
       return moneyFmt(num)
    },
    changeAuditingType(index){
     this.selectFlag = index
    },
    goBack(){
      this.$router.go(-1)
    },

    getWxCodeAccountInfo() {
      console.log('=========请求账户信息')
      getOfficialAccountInfo().then(response =>{
        if(response.code === 200){
            this.account = response.data;
        }
      });
    },

        // 获取列表数据
    informPort(flag) {
      let year = this.currentDate.getFullYear();
      let getMonth = this.currentDate.getMonth() + 1;
      let month =  getMonth.toString().padStart(2, '0')
      let date = this.currentDate.getDate()
      let startTime = `${year}-${month}-${date}`
      console.log(startTime)
      getOfficialList(this.pageNum,startTime).then(res => {
        console.log(res)
        if (res.code == 200 && res.rows) {
          console.log(res)
          let dataList = res.rows
          if (dataList && dataList.length) {
            if (flag) {
              this.incomeList = dataList
            } else {
              this.incomeList = [...this.incomeList, ...dataList]
            }
          }
          this.pageTotal = res.total
          this.loading = false
          this.finished = false
          if (this.incomeList.length >= this.pageTotal) {
            this.bomTitle = '到底了~ ' + '共计' + res.total + '条'
            this.finished = true
          } else {
            this.pageNum += 1
            this.bomTitle = ''
          }
        }
      })
    },
    // 下拉刷新
    onRefresh() {
      this.pageNum = 1
      this.finished = true
      this.loading = true
      this.incomeList = []
      this.isLoading =true
      setTimeout(() => {
        this.isLoading = false // 结束下拉刷新的加载状态
        this.informPort(true) // 重新获取列表数据
        this.$toast.success('刷新成功')
      }, 300)
    },
    // 上拉加载
    onLoad() {
      this.informPort() 
      // 获取更多列表数据
      
    },

  formatter(type, val) {
      if (type === 'year') {
        return `${val}年`;
      } else if (type === 'month') {
        return `${val}月`;
      }
      return val;
  },
  confirmTime(val){
    console.log(val)
    console.log(this.currentDate)
    //关闭弹窗
    this.show = false;
    //修改年月
    this.year = val.getFullYear();
    let getMonth = val.getMonth() + 1
    this.month = getMonth.toString().padStart(2, '0')
    this.pageNum = 1
    this.incomeList = []
    this.informPort(true)

  },
   selectDate(){
    this.show =true;
   },
  },

};
</script>

<style lang="less" scoped>
// 主题 padding
.auditng {
    width: 100%;
    height: 100vh;
    background: url(@/assets/img/my_bg.png) no-repeat left center;
    background-size: 100% 100%;
    overflow: hidden;
    padding-top:4px;
}
.auditng .fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10;
  height: 15rem;
}
.auditng .fixed .head {
  width: 85%;
  background: url(@/assets/img/my_info_bg.png) no-repeat left center;
  background-size: 100% 100%;
  margin: 0 auto;
  margin-top: 3%;
  border-radius: 8px;
  padding: 9%;
  height: 78%;
}

.auditng .fixed .head .text {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #d8d7d7;
  letter-spacing: 0;
  font-weight: 400;
  padding: 0 5px;
}
.auditng .fixed .head .money {
  font-family: PingFangSC-Medium;
  font-size: 30px;
  font-weight: 500;
}
.auditng .fixed .head .text1 {
  margin-top: 1%;
}
.auditng .fixed .head .text2 {
  margin-top: 2%;
  color: #fff;
}
.auditng .fixed .head .text3 {
  margin-top: 4%;
  display: flex;
  justify-content: space-between;
}
.auditng .fixed .head .text4 {
   margin-top: 2%;
   margin-bottom: 2%;
  display: flex;
  justify-content: space-between;
}
.auditng .fix {
  height: 12rem;
}
.auditng .detail {
  background: url(@/assets/img/auditing_detail_bg.png) no-repeat left center;
  background-size: 100% 100%;
  margin: 0 auto;
  margin-top: 3%;
  border-radius: 8px;
  padding: 20px;
  padding-bottom: 60px;
}


.tabbar {
    margin-top: 2%;
    display: flex;
    justify-content: space-around;
    font-size: 14px;
    color: #fff;
    font-weight: 400;
    .bar_item {
        background-color: rgb(156, 156, 156);
        border-radius: 8px;
        padding: 2px 8px;
    }
    .select {
      text-align: center;
      font-weight: 700;
      position: relative;
      background-color: rgb(106, 171, 187);
      &::after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: 0;
        height: 6rpx;
        width: 60rpx;
        background: #111;
        transform: translateX(-50%);
        border-radius: 30rpx 30rpx 0rpx 0rpx;
      }
    }
  }
.no_data {
  margin-top: 20%;
  font-weight: 700;
}
 .last_income_text{    
    color: #fff;
    margin-left: 17px;
    margin-top: 10px;
    font-size: 16px;
    font-weight: 600;
  }

.list {
  padding-bottom: 16px;
}
.list .list_item {
  display: flex;
  align-items: center;
  padding: 10px 22px;
  position: relative;
  margin-top: 1px;
  border-bottom: 1px solid #516388;
}
.list .list_item .jiao {
  position: absolute;
  right: 22px;
  top: 0;
}
.list .list_item .jiao img {
  width: 64px;
  height: 18px;
}
.list .list_item .jiao .wait {
  width: 52px;
}
.list .list_item .jiao .not {
  width: 76px;
}
.list .list_item .typeIcon {
  width: 35px;
  height: 35px;
  margin-right: 8px;
}
.list .list_item .item_l,
.list .list_item .item_r {
  flex: 1;
}
.list .list_item .item_l .text1,
.list .list_item .item_r .text1 {
  font-size: 16px;
  color: #f8f8f8;
  line-height: 16px;
}
.list .list_item .item_l .text2,
.list .list_item .item_r .text2 {
  font-size: 14px;
  color: #f8f8f8;
  line-height: 14px;
  font-weight: 400;
}
.list .list_item .item_l .mb20,
.list .list_item .item_r .mb20 {
  margin-bottom: 8px;
}
.list .list_item .item_r {
  text-align: right;
}
.list .list_item .item_r .money {
  text-align: right;
  position: absolute;
  right: 22px;
  top: 50%;
  font-size: 14px;
  color: rgb(177,213,189);
  font-weight: 400;
  transform: translateY(-50%);
}
.income_year {
    width: 90%;
    height: 44px;
    font-size: 18px;
    color: #fff;
    background-color: rgb(40 60 93);
    margin: 0 auto;
    margin-top: 6px;
    padding: 6px 20px;
    border-radius: 23px;
}
.fix_year {
  height: 50px;
}
</style>